/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Add material function
 */
export const AddMaterialFunctionBody = zod.object({
  functionId: zod.uuid().describe("Material Function identity."),
});

export const AddMaterialFunctionResponse = zod.uuid().describe("Material Function identity.");

/**
 * @summary Remove material function
 */
export const RemoveMaterialFunctionResponse = zod.void();
